import { render, staticRenderFns } from "./product-list.vue?vue&type=template&id=e5e6ebde&scoped=true"
import script from "./product-list.vue?vue&type=script&lang=js"
export * from "./product-list.vue?vue&type=script&lang=js"
import style0 from "./product-list.vue?vue&type=style&index=0&id=e5e6ebde&prod&lang=less&scoped=true"
import style1 from "./style/h5-product-list.less?vue&type=style&index=1&id=e5e6ebde&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e6ebde",
  null
  
)

export default component.exports